import { Button } from "@mui/material";
import withConfirmation from "./withConfirmation";

export default withConfirmation(Button);
